import config from '../services/config';
import globals from '../services/globals';
import dataManager from '../services/dataManager';
import { createRouter, createWebHistory } from 'vue-router';
import bus from '../main';



const $ = window.$;
var TScMessenger = window.TScMessenger;
let versionNumber = process.env.VUE_APP_VERSION;

let isTruckScienceAPIUser = location.href.indexOf('truck-science') !== -1 ? true : false;
let optionalApiUserPathPrefix = '';
if(isTruckScienceAPIUser) {
    optionalApiUserPathPrefix = '/truck-science';
    TScMessenger.writeDebugMessage('router/index.js, setting up RP relevant router paths');
}

let ROUTES = {
    NOT_FOUND: {
        path: '/:pathMatch(.*)*',
        redirect: optionalApiUserPathPrefix + '/get_started'
        // redirect: to => {
        //     // the function receives the target route as the argument
        //     // we return a redirect path/location here.
            
        //     if (globals.user.getAppRefreshUnderway()/* || (globals.user.getEmailAddress() !== '' && globals.user.getEmailAddress() !== null && globals.user.getEmailAddress() !== undefined)*/) {
        //         console.log("In catchAll route, redirecting to selection from: " + to.path);
        //         return { path: '/selection' };
        //     }
        //     console.log("In catchAll route, redirecting to get_started from: " + to.path);
        //     return { path: '/get_started' };
        //   },
    },
  GET_STARTED: {
      name: 'getstarted',
      meta: {
          route: 'get_started(/:mode)',
          moduleId: 'viewmodels/get_started',
          title: '4873',
          nav: false,
          id: 'get-started-id',
          hash: '/get_started',
          tooltip: '1066',
      },
      path: optionalApiUserPathPrefix + '/get_started',
      component: () => import('@/views/GetStartedView.vue'),
      beforeEnter: (to, from) => {
        globals.showSpinner();
        TScMessenger.writeDebugMessage('router/index.js, get_started, beforeEnter');
        //prevent navigation back to module when browser refresh or app refresh detected
        
        
        if(localStorage.getItem('overrideRouterLogicAndGoToGetStarted')) {
        // if(globals.overrideRouterLogicAndGoToGetStarted) {
            globals.dataModelReady.value = true;
            globals.user.removeAppRefreshUnderway();
            globals.hideSpinner();
            return true;
        }else if(localStorage.getItem('externalAccessAPIUser')) {
            let externalAccessInfoForAPIUser = localStorage.getItem('externalAccessAPIUser');
            
            localStorage.removeItem('externalAccessAPIUser');
            // globals.spinnerText.value = 'Re-attempting opening of vehicle...';
            // TScMessenger.writeDebugMessage('router/index.js, get_started, beforeEnter, re-attempting opening of vehicle after update');
            return { name: ROUTES.EXTERNAL_ACCESS.name, hash: externalAccessInfoForAPIUser };
            
        }else if (globals.user.getAppRefreshUnderway() || (( 
        (performance !== undefined && performance.navigation !== undefined && performance.navigation.type !== undefined && performance.navigation.type === 1) || 
        (globals.user.getEmailAddress() !== '' && globals.user.getEmailAddress() !== null && globals.user.getEmailAddress() !== undefined) || localStorage.getItem('authMethod')) && globals.getAlreadyAuthenticated() === 'YES')) {
            // TScMessenger.writeDebugMessage('In get_started before enter... returning selection... to.query: ' + to.query.mode  + ', from.query: ' + from.query.mode + ', version: ' + versionNumber);
            return { name: ROUTES.SELECTION.name }
        } else {
            // TScMessenger.writeDebugMessage('In get_started before enter... returning get_started... to.query: ' + to.query.mode  + ', from.query: ' + from.query.mode + ', version: ' + versionNumber);
            if(to.query.mode) {
                // to.query.mode = from.query.mode;
                localStorage.setItem('mode', to.query.mode);
            }
            
            globals.dataModelReady.value = true;
            if(!(globals.user.getAccessCode() !== '' && globals.user.getAccessCode())) {
                globals.hideSpinner();
            }else  {
                globals.showSpinner();
                if(globals.preventHideSpinner) {
                    return false;
                }
            }
            //continue as normal
            return true;
        }
      }
  },
//   SIGN_UP: {
//     name: 'signup',
//     meta: {
//         route: 'signup',
//         moduleId: 'viewmodels/signup',
//         title: 'Sign Up',
//         nav: false,
//         id: 'signup-id',
//         hash: '/signup',
//         tooltip: '1066',
//     },
//     path: '/signup',
//     component: () => import('@/views/SignUpView.vue'),
//     beforeEnter: (to, from) => {
//     //   globals.showSpinner();
//       TScMessenger.writeDebugMessage('In sign up before enter... ' + versionNumber);
      

//       return true;
//     }
// },
  SELECTION: {
      name: 'selection',
      meta : {
          route: 'selection',
          moduleId: 'viewmodels/selection',
          title: '4874',
          nav: false,
          id: 'selection-id',
          hash: '/selection',
          tooltip: '1066',
      },
      path: optionalApiUserPathPrefix + '/selection',
      component: () => import('@/views/SelectionView.vue'),
      beforeEnter: (to, from) => {
        // globals.showSpinner();
        TScMessenger.writeDebugMessage('router/index.js, selection, beforeEnter');
        //prevent navigation back to module when browser refresh or app refresh detected
        
        if(localStorage.getItem('overrideRouterLogicAndGoToGetStarted')) {
        // if(globals.overrideRouterLogicAndGoToGetStarted) {
            globals.dataModelReady.value = true;
            globals.user.removeAppRefreshUnderway();
            return { name: ROUTES.GET_STARTED.name };
        }else if(localStorage.getItem('externalAccessAPIUser')) {
            let externalAccessInfoForAPIUser = localStorage.getItem('externalAccessAPIUser');
            
            localStorage.removeItem('externalAccessAPIUser');
            // globals.spinnerText.value = 'Re-attempting opening of vehicle...';
            // TScMessenger.writeDebugMessage('Router, selection beforeEnter, re-attempting opening of vehicle after update...');
            return { name: ROUTES.EXTERNAL_ACCESS.name, hash: externalAccessInfoForAPIUser };
            
        }else if(globals.user.getAppRefreshUnderway() || 
            (((globals.user.getEmailAddress() !== '' && globals.user.getEmailAddress() !== null && globals.user.getEmailAddress() !== undefined) || localStorage.getItem('authMethod')) && globals.getAlreadyAuthenticated() === 'YES')) {
            // TScMessenger.writeDebugMessage('In selection before enter, returning true... ');
            return true;
        }else {
            // TScMessenger.writeDebugMessage('In selection before enter, returning false... ');
            return { name: ROUTES.GET_STARTED.name };
        }

        
      }
  },
  CONFIGURATION: {
      name: 'configuration',
      meta: {
          route: 'configuration(/:mode)',
          moduleId: 'viewmodels/offer/configuration/configuration',
          title: '4875',
          nav: true,
          id: 'configuration-id',
          hash: '/configuration',
          dataAvailabilityCode: 'ActiveConfiguration',
          tooltip: '1061',
      },
      path: optionalApiUserPathPrefix + '/configuration',
      component: () => import('@/views/offer/ConfigurationView.vue'),
      beforeEnter: ((to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, configuration, beforeEnter');
        globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
        return true;
      })
  },
  PERFORMANCE: {
      name: 'performance',
      meta: {
          route: 'performance',
          moduleId: 'viewmodels/offer/performance',
          title: '4876',
          nav: true,
          id: 'performance-id',
          hash: '/performance',
          dataAvailabilityCode: 'ActivePerformance',
          tooltip: '1062',
      },
      path: optionalApiUserPathPrefix + '/performance',
      component: () => import('@/views/offer/PerformanceView.vue'),
      beforeEnter: ((to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, performance, beforeEnter');
        globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
        return true;
      })
  },
  COSTING: {
      name: 'costing',
      meta: {
          route: 'costing',
          moduleId: 'viewmodels/offer/costing',
          title: '4877',
          nav: true,
          id: 'costing-id',
          hash: '/costing',
          dataAvailabilityCode: 'ActiveCosting',
          tooltip: '1063',
      },
      path: optionalApiUserPathPrefix + '/costing',
      component: () => import('@/views/offer/CostingView.vue'),
      beforeEnter: ((to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, costing, beforeEnter');
        globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
        return true;
      })
  },
  SPECIFICATION: {
      name: 'specification',
      meta: {
          route: 'specification',
          moduleId: 'viewmodels/offer/specification',
          title: '4878',
          nav: true,
          id: 'specification-id',
          hash: '/specification',
          dataAvailabilityCode: 'ActiveSpecification',
          tooltip: '1064',
      },
      path: optionalApiUserPathPrefix + '/specification',
      component: () => import('@/views/offer/SpecificationView.vue'),
      beforeEnter: ((to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, specification, beforeEnter');
        globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
        return true;
      })
  },
  SUMMARY: {
      name: 'summary',
      meta: {
          route: 'summary',
          moduleId: 'viewmodels/offer/summary',
          title: '4879',
          nav: true,
          id: 'summary-id',
          hash: '/summary',
          dataAvailabilityCode: 'ActiveSummary',
          tooltip: '1065',
          faClasses: 'fas fa-file-pdf',
      },
      path: optionalApiUserPathPrefix + '/summary',
      component: () => import('@/views/offer/SummaryView.vue'),
      beforeEnter: ((to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, summary, beforeEnter');
        globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
        return true;
      })
  },
  EXTERNAL_ACCESS: {
      name: 'externalAccess',
      meta: {
          route: 'externalAccess(/:accessCode)',
          moduleId: 'viewmodels/externalAccess',
          title: '4880',
          nav: false,
          id: 'externalAccess-id',
          hash: '/externalAccess',
          tooltip: '1066'
      },
      path: optionalApiUserPathPrefix + '/externalAccess',
      component: () => import('@/views/ExternalAccessView.vue'),
      beforeEnter: (to, from) => {
        TScMessenger.writeDebugMessage('router/index.js, externalAccess, beforeEnter');
        if (to !== undefined && to.query && to.query.accessCode && to.query.accessCode !== '') {
            localStorage.setItem('accessCode', to.query.accessCode);
            globals.dataModelReady.value = true;
            return true;
        } else if (to !== undefined && to.query && to.query.accessFlag && (to.query.accessFlag === 'embed' || to.query.accessFlag === 'tab')) {
            localStorage.setItem('accessFlag', to.query.accessFlag);
            // globals.dataModelReady.value = true;
            globals.dataModelReady.value = true;
            return true;
        }  else if (to !== undefined && to.hash && to.hash.indexOf('accessFlag') !== -1 && (to.hash.indexOf('accessFlag=embed') !== -1 || to.hash.indexOf('accessFlag=tab') !== -1)) {
            localStorage.setItem('externalAccessAPIUser', to.hash);
             globals.checkForUpdate(to).then(function (result) {
                if(result.UpdateCheckResult === 'continue_with_externalAccess') {
                    // TScMessenger.writeDebugMessage('In router external access, after update check, continuing...');
                    // TScMessenger.writeDebugMessage('In externalAccess beforeEnter, hash detected, routing to externalAccess...');
                    localStorage.setItem('accessFlag', to.hash);
                    // globals.dataModelReady.value = true;
                    globals.dataModelReady.value = true;
                    return true;
                } else {
                    // TScMessenger.writeDebugMessage('In router external access, after update check, aborting due to update detected...');
                    return { name: ROUTES.SELECTION.name }
                }
            });
            // TScMessenger.writeDebugMessage('In externalAccess beforeEnter, hash detected, routing to externalAccess...');
            // localStorage.setItem('accessFlag', to.hash);
            // // globals.dataModelReady.value = true;
            // globals.dataModelReady.value = true;
            // return true;
        }else {
            return { name: ROUTES.GET_STARTED.name };
        }
      }
  }
};
const startingRoutes = [ROUTES.GET_STARTED, /*ROUTES.SIGN_UP,*/ ROUTES.EXTERNAL_ACCESS, ROUTES.SELECTION, ROUTES.NOT_FOUND];
const router = createRouter({
  history: createWebHistory('/'),
  routes: startingRoutes
});
// Global guards also run when a mounted externalAccess record is reused.
router.beforeEach(to => {
    if (to.name !== ROUTES.EXTERNAL_ACCESS.name) return true;
    const clean = window.TruckScienceLaunch.sanitize(to.fullPath);
    if (clean !== to.fullPath) {
        const url = new URL(clean, location.origin);
        return { path: url.pathname, query: Object.fromEntries(url.searchParams), hash: url.hash, replace: true };
    }
    return true;
});
// router.beforeEach((to, from) => {
//     // next(vm => {
//     //     globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
//     // });
//     console.log("In beforeEach: to: " + to.name + ", from: " + from.name);
//     return true;
//   });

// router.beforeResolve((to, from) => {
//     globals.sendModuleDataToIntercom(to, from, dataManager.sendInfoToIntercom);
// });

// router.afterEach((to, from, failure) => {
//   // if(globals.displayBlackout !== undefined) {
//   //   globals.displayBlackout = false;
//   //   globals.displaySpinner = false;
//   // }
//   return true;
// })

export { router, ROUTES };
